<template>
  <div class="lang-switcher" ref="langRoot" :class="{'navbar-mode': navbarMode}">
    <div class="lang-btn" @click="toggleDropdown">
      <img class="lang-flag-img" :src="'https://flagcdn.com/20x15/' + activeFlag + '.png'" :alt="activeKey" />
      <span class="lang-code">{{ activeKey }}</span>
      <i class="fas fa-chevron-down" :class="{open: dropdownOpen}"></i>
    </div>
    <transition name="lang-drop">
      <div class="lang-dropdown" v-show="dropdownOpen">
        <div v-for="(language, index) in settingsLanguage" :key="language.id"
             @click="changeLanguage(index)"
             class="lang-option"
             :class="{active: language.selected}">
          <img class="lang-flag-img" :src="'https://flagcdn.com/20x15/' + language.flagCode + '.png'" :alt="language.shortName" />
          <span class="lang-name">{{ language.name }}</span>
          <i v-if="language.selected" class="fas fa-check"></i>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { settingsLanguage } from '@/language/settings.js'

export default {
  name: 'LangSwitcher',
  props: {
    navbarMode: { type: Boolean, default: false }
  },
  data() {
    return {
      settingsLanguage,
      dropdownOpen: false
    };
  },
  computed: {
    activeKey() {
      return Object.keys(this.settingsLanguage).find(k => this.settingsLanguage[k].selected) || 'ES';
    },
    activeFlag() {
      const lang = this.settingsLanguage[this.activeKey];
      return lang ? lang.flagCode : 'es';
    }
  },
  created() {
    const saved = localStorage.getItem('language') || 'ES';
    Object.keys(this.settingsLanguage).forEach(k => {
      this.settingsLanguage[k].selected = k === saved;
    });
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    handleOutsideClick(e) {
      if (this.$refs.langRoot && !this.$refs.langRoot.contains(e.target)) {
        this.dropdownOpen = false;
      }
    },
    changeLanguage(index) {
      Object.keys(this.settingsLanguage).forEach(k => {
        this.settingsLanguage[k].selected = false;
      });
      this.settingsLanguage[index].selected = true;
      localStorage.setItem('language', index);
      localStorage.setItem('languageInfo', localStorage.getItem(index));
      this.dropdownOpen = false;
      this.$router.go();
    }
  }
}
</script>

<style scoped>
.lang-switcher {
  position: relative;
}

/* ── Botón principal ── */
.lang-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  transition: background 0.2s;

  /* modo público (fondo blanco) */
  background: #fff;
  border: 1px solid #4f99c4;
  color: #4f99c4;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
}
.lang-btn:hover {
  background: #f0f7fc;
}

/* modo navbar (fondo transparente sobre barra oscura) */
.navbar-mode .lang-btn {
  background: transparent;
  border: 1px solid rgba(255,255,255,0.5);
  color: #fff;
  box-shadow: none;
}
.navbar-mode .lang-btn:hover {
  background: rgba(255,255,255,0.12);
}

.lang-flag-img { width: 20px; height: 15px; object-fit: cover; border-radius: 2px; flex-shrink: 0; }
.lang-code     { font-size: 0.82em; letter-spacing: 0.06em; }

.fa-chevron-down { font-size: 0.68em; transition: transform 0.2s; }
.fa-chevron-down.open { transform: rotate(180deg); }

/* ── Dropdown ── */
.lang-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  background: #fff;
  border: 1px solid #dde5ee;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.14);
  min-width: 155px;
  overflow: hidden;
  z-index: 9999;
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  color: #444;
  transition: background 0.15s;
}
.lang-option:hover  { background: #f0f7fc; }
.lang-option.active { color: #4f99c4; font-weight: 600; }
.lang-name          { flex: 1; }
.lang-option .fa-check { color: #4f99c4; font-size: 0.82em; }

/* ── Animación ── */
.lang-drop-enter-active,
.lang-drop-leave-active { transition: opacity 0.15s, transform 0.15s; }
.lang-drop-enter,
.lang-drop-leave-to     { opacity: 0; transform: translateY(-6px); }
</style>
